import { render } from "./SignUp.vue?vue&type=template&id=08013cc4"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=08013cc4&lang=css"
script.render = render

export default script